module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“B")])]), _vm._v("e right there!” Sarah Harper gave up looking for her favorite spatula, then shoved the electric mixer to the back of the countertop, handed her two-year-old daughter an icing-covered beater and hurried to answer the doorbell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If the caller wanted to sell her encyclopedias or a vacuum cleaner he was in big trouble. A hundred cookies sat on the kitchen’s butcher-block work island waiting to be frosted, there were more in the oven, and Sarah was running behind. She’d been rushing ever since returning to town after spending two weeks caring for her aunt, who’d had surgery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dazzling Montana sunshine spilled through the screen as she opened the pretty Victorian’s inside door and squinted up at the tall man on the porch. As her eyes adjusted to the morning’s brightness, she got a quick impression of faded jeans, a blue plaid shirt and good shoulders on a lean, rangy frame.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suddenly, shock razed Sarah’s nerve endings, and all thoughts of her catering business, wedding cookies, mini quiches and sherbet punch vanished in a rush of panic. Quickly, she schooled her expression—tried to pretend she didn’t remember the cowboy on the porch. But as she watched his cordial smile fade and saw stunned recognition rise in his eyes, she knew pretending was a waste of time. He knew her too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah took a deep breath and swallowed. “Hello, Jake.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello, Sarah,” he said in the same hesitant tone. “It’s been a long time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” she replied nervously. “Yes, it has.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His voice was as deep as she remembered, yet the faint lines beside his dark blue eyes were a mystery, since she couldn’t say if they’d been there before. But the moon over Cotton Creek had left her with a memory of high cheekbones, rugged features and collar-length dark hair. Now she could see that it wasn’t just dark, but as black as the Stetson tugged low on his forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like those eyes, his hair color came as no surprise. She’d kissed those colors good morning every day for the past twenty-eight months…tucked those colors in every night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For-forgive me,” she stammered, tugging the inside door nearly shut behind her. “I’m usually a little more together than this. It’s just that…you’re the last person I expected to see when I opened the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Same here,” he murmured, still assessing her uncertainly. “You said you were leaving Comfort.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d said a lot of things that night, none of which she wanted to remember. “Do you need directions?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His gaze narrowed curiously. “Directions?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah nodded, praying that Kylie would stay in the kitchen with her tiny muffins and tea set. “Yes. If you didn’t expect to see me, then that must mean you’re looking for someone else.” She drew a deep breath and released it on a tremble. “Doesn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not sure. Why are you so nervous?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not,” she said, startled by his bluntness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The last man she’d slept with glanced, frowning, into the front lawn where Sarah’s fancy sign read Miss Lillian’s Bed and Breakfast. When he faced her again, their past was in his eyes. Though, how could he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" think about it? Beneath her apprehension and embarrassment, even she was having a hard time keeping her memories at bay. They’d been wild together.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sarah, I apologize if this makes you uneasy, but I really need a room. Just until I can find an apartment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dear God.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For now, I’m staying at the motel outside of town,” he continued. “But rooming here would be more convenient. It’s closer to my office.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She managed to find her voice. “Your office?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. In a nutshell, I’ve been hired to finish your ex-sheriff’s term. I guess you haven’t heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. I—I’ve been away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I see. Well, I’ll be here until January. Longer if I like the town and the town likes me.” He nodded at the door she guarded so resolutely. “Would it be all right if I came in and looked around? I’d like to see your rooms.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No! No, he couldn’t! “I’m sorry,” she blurted, “but I don’t have any rooms available right now. And I don’t think anyone else in town takes in boarders.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then the vacancy sign out front is a mistake?” His mouth thinned grimly. “Maybe I should be talking to Miss Lillian.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The second lie rushed out, even more desperate-sounding than the first. “What I meant to say is, I’m closing. This is my place. Miss Lillian passed away several years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake moved closer to the door, and Sarah took an uneasy step backward. A late-August breeze carried the earthy scent of his aftershave to her. She detected a marked difference in him from the man she remembered. This man was strong and confident—self-assured and determined. And suddenly she knew that his baring his soul to her that night had been an anomaly. He’d only shared his past because he was wounded and hurting, and he’d never expected to see her again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Look,” he said. “If you’re worried about what happened between us before, I don’t plan on repeating it. All I want is a warm bed and a roof over my head, preferably a little cleaner and a little closer to my office than the Twirling Spurs Motel. I wouldn’t be here long, and I’m willing to pay whatever you want. Right now, I just need to find somewhere to—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suddenly his gaze shifted from her face to a spot somewhere behind and to the left of her, and his grave features gentled. “Well, now,” he said. “Who do we have here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miserable, Sarah turned around, already knowing who she’d see. As they’d talked, the inside door had drifted open and Kylie stood in the hall, silky black hair skimming her narrow shoulders, blue eyes peeking shyly from beneath her bangs. She was still wearing her pink eyelet nightie, and the beater in her hand was now frosting-free—which was more than Sarah could say for her daughter’s hands and face. Kylie ran to her, and Sarah lifted her into her arms, praying that she would never know the fear her mother was experiencing at this moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s your name, cutie?” Jake asked with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kylie hid her face in Sarah’s neck and whispered, “More f’osting, Mommy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Frosting,")]), _vm._v(" Sarah thought gratefully. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cookies.")]), _vm._v(" An excuse to terminate the conversation. “In a minute, sweetheart,” she answered, and faced Jake again. “I’m sorry, but I have cookies in the oven. I hope you find an apartment soon, Mr.—” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, God, she didn’t know his last name.")]), _vm._v(" They’d been as intimate as a man and woman could be, yet they hadn’t exchanged the simplest information.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s Russell,” he supplied quietly, then added, “Sarah, relax. We didn’t do anything wrong. We both needed a friend that night. I was glad you were there for me, and I think you felt the same. At least until—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah jerked away from the screen. “I have to go. You might want to check the paper for apartments. Our weekly comes out today.” Then, before he could speak again, she shut the inside door and collapsed against it, tears filling her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t have one-night stands! She didn’t! Yet the child in her arms was proof positive that, once, she had done just that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah hugged Kylie close, kissed her hair, then put her down and watched her run into the kitchen. He couldn’t know. This man who had always longed for family—this man she’d known for only "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("one hour")]), _vm._v("—would want to be part of his child’s life. It was as certain as snow in winter. And Sarah would never share her daughter with a stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d barely taken a step when she acknowledged the other reason for her anxiety. Beneath his questions and her fears, the electric attraction they’d encountered three years ago was still there. And if Jake learned that Kylie was his, they’d be thrown together again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe her life wasn’t a thrill a minute, but it was stable, orderly and uncomplicated, and she liked it that way. She didn’t know what would happen if hormones and memories tested her judgment…again.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pulse pounding, Jake left the sparsely populated outskirts of town and drove back toward his office. On his left, towering mountain peaks rose out of thick, rich timberland to pierce the blue sky. But he was only half-aware of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was thinking of Sarah. Pretty, honey-blond, brown-eyed Sarah. Pretty, frightened-to-the-bone Sarah.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He understood the awkwardness. They had intimate knowledge of each other—and they’d never expected to see each other again. Hell, he hadn’t been sure of what to say at first, either. But why the anxiety? Why the rattled, frantic behavior? Unless…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A child usually meant there was a husband in the picture. Was she afraid that if she rented Jake a room, her new husband would see the tension between them and start asking questions? Or, he wondered, scowling, had she gone back to the womanizing creep she’d divorced?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He plucked his sunglasses from the visor and slipped them on, his mind rolling back to that night in the tall grass—just as it had so many times after he’d returned home from his discouraging visit here. It all came back—all the heat, all the desperation, and all the guilt. Because it had been clear that any pleasure she’d derived from their lovemaking had disappeared when they were both able to breathe normally again and she’d faced what she’d done.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake sighed. He’d known she wasn’t thinking straight that night; he shouldn’t have let it go that far. But chemistry was chemistry, and he’d put nobility on the back burner and taken the comfort he’d needed, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Punching a few buttons, he found an upbeat country song on the radio and acknowledged the feeling in his gut that said the chemistry was still there. But he wouldn’t bother her again. Even if she weren’t already attached, she wasn’t the kind of woman he looked for these days. She was too sweet, too wholesome—and despite the fevered way they’d come together—too principled. All he wanted from a woman these days was an occasional date and some no-strings sex. He’d given up the two-point-five kids and picket-fence myth. Dear, deceitful little Heather had set him straight on that score.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Although, if he had to be honest, his trust in women had been shaken a lot earlier than that. A boy couldn’t grow up knowing he was an afterthought in his own mother’s life without having a few hang-ups.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A horn blast jarred him, and Jake spiked the brake as a white truck bearing Idaho plates shot across the road in front of him. Quickly, he looked across the intersection to check for a stop sign, then swore when he spotted it—flattened at the side of the road. Obviously, the out-of-state driver hadn’t seen it. Jake nearly gave chase, then decided against it. There was no point wasting time on an arrest that wouldn’t hold up. The best he could do now was see that the sign was fixed before someone got hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The midmorning sun glinted off the sheriff department’s white Jeep as Jake pulled his tan Mountaineer in beside it. He got out and slammed the door. As he walked past the wide front window with its fancy gold seal, he waved at Maggie Dalton, who was just hanging up the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hi, again,” he said, coming inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hi.” She finished scribbling a note, added it to a pile and sent him a friendly smile. “Didn’t expect you back so soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m fast. Anybody report a downed stop sign at the corner of Mountain and Prairie?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yep. County maintenance is on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The reception area was fairly large, with the dispatcher’s desk in the middle of the room, and flanked on both sides by a low-railing fence with a swinging gate. To the right stood a row of straight-back chairs and the door to the lockup; to the left, Jake’s private office. Above the waist-high wood paneling, the walls were pale municipal green and needed a fresh coat of paint.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake hung his hat on a peg by the door, then walked to the desk and nodded at the stack of messages that hadn’t been there an hour ago. “Some of those for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nope, all of them. Nothing too pressing. Judge Quinn wants you to stop by his office at the courthouse sometime this week—but not Friday, he’s going fishing. And there’s a town council meeting on Friday that you’re required to attend. The list of topics to be discussed is in the computer. I’ll print it out for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A teasing grin lit her eyes. “Oh. And the mayor wants you to join her for dinner before the meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s the grin for?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Was I grinning? Gee, I didn’t mean to.” Still fighting a smile, she handed him his messages. “The rest are mostly well-wishes from businessmen. They’d like you to return their calls when you get time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake sifted through them, deciding that whatever had tickled her fancy was destined to remain a secret. “Anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your uniforms arrived. I put them in your office.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks. I’ll change before I start my shift.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His deputy was a pretty woman in her late twenties with a long black braid and brown eyes, and from the little he’d seen, organized, focused and good at her job. A jittery feeling pooled in his belly. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She was also Ross Dalton’s brand-new wife.")]), _vm._v(" He’d been stunned—and pleased—to receive an invitation to their wedding at the Brokenstraw Ranch when he’d toured the town a week ago. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Life was full of surprises.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So, did you get a room at Miss Lillian’s?” Maggie asked. “Or did your male pride balk at living in a pink house?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The color was fine.” In fact, he’d found it striking with all the curlicued white gingerbread and spindled railings on the wraparound porch. He even liked the lace curtains and tiny candle-lights in the front windows. “Unfortunately,” he said, frowning, “the owners are closing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie blinked in surprise. “After just having it painted? I spoke to Sarah yesterday, and she never mentioned it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No surprise there. The way she’d acted, he’d bet a month’s salary that she hadn’t planned to do any such thing until he’d shown up. He’d also bet she’d reopen the instant he found a permanent residence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did Sarah say why she was closing?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, she just told me to check the want ads. Maybe she and her husband don’t want strangers roaming the house with their daughter being so young.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie clicked on the computer to her right and scanned a file list. “Interesting theory, but Sarah’s not married.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake froze for several seconds, then tucked his messages in his breast pocket. His blood clipped along a little faster.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In fact,” Maggie added, “if she hadn’t divorced Vince Harper a few years ago, technically she’d be a widow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was so startled, he couldn’t keep his shock from showing. “Sar—the woman I just spoke to was married to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vince Harper?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie punched a key on the keyboard, and the printer started spitting out data. “I take it you’ve heard the name?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Headlines hyping Harper’s notorious diamond theft blazed through Jake’s mind, complete with a mug shot of a smirking man with a long blond ponytail. “Oh, yeah,” he said, scowling. “I’ve heard it. Somehow, I can’t imagine…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sarah with him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake nodded. If he remembered correctly, Harper had been a bona fide loser for most of his adult life. No wonder Sarah had said the things she had the night they met. He pictured the three of them together—Harper, Sarah and that cute little girl—and held back another scowl. No way did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" picture look right.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie ripped a sheet from the printer. “Here’s the topic list for Friday’s meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks. Now, if you can just find me a place to hang my hat…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry, the best I can do is bring in the paper when it comes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good enough.” He grinned, then crossed the floor to his office, sank into his swivel chair and stared into space.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah had been married to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vince Harper?")]), _vm._v(" The smalltime hood who’d knocked over a Florida jeweler and gotten away with the gems? Unbelievable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake had been working in Glacier County when it happened, but most lawmen in Montana knew the case well. The feds had put out an urgent APB, figuring that Harper would head for home. Agents had ended up apprehending the jerk while he was meeting his needs at a brothel a few miles outside of Comfort. After finding only a few diamonds on him, they’d searched the premises, without success. Then they’d learned that he’d spent time at his ex-wife’s home the previous night, and they’d searched Sarah’s house, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The remaining diamonds had never been recovered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake eased back in his chair. Now that he remembered the time frame, the scandal had occurred right around when he’d found Sarah crying in that grassy overflow parking lot. But she hadn’t mentioned the diamonds or feds that night. She’d only told him that her divorce had just become final, and she was through with marriage. Or anything close to it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d understood. Fate, or karma or whatever power ruled the worlds of the romantically unlucky had handed him a big fat heartache only a week before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The carnival aromas of cotton candy and French fries drifted in from Jake’s memory, and suddenly he could smell them, and hear the music floating down from the Founder’s Day celebration two streets away. He caught the faint perfume of the summer cottonwoods, too, and the stirring fragrance of the teary woman in his arms. They’d emptied their souls, and had danced. Because nothing comforted better than a human touch….")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t cry,” he whispered, trying to keep his attraction under wraps as they moved together in the calf-high grass. “Believe me, you’re better off without a cheat and a liar.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know,” she answered in a ragged voice. “It’s not that I still care about him—I don’t. I don’t ever want to see him again. But I’ll miss being in love.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You won’t miss it for long. You’re a beautiful woman. There’ll be someone else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah shook her head. “No, I don’t trust my judgment anymore. I was so sure he was good, and decent, and… And he was none of those things. I won’t chance marriage again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re prepared to be alone for the rest of your life?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s better than hurting all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake had to agree. Since Heather, he’d adopted a new philosophy. Don’t expect too much from a relationship and you won’t be disappointed. But God, he thought, shortening his steps to a gentle rock and sway, it still felt good to hold someone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d thought he couldn’t feel any lower when he’d found out Heather was sleeping around. He’d been wrong. On the heels of that, he’d learned that the father he’d never known—the father he’d imagined and hoped for as a child—had died. But his dad had sired two other sons. That’s why Jake had traveled three hundred miles to Comfort, Montana. He’d come to meet his brothers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You should tell your brothers who you are,” Sarah murmured, seeming to read his mind. “It’s too late to do anything about your dad, but you do have other family.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I tried. Walked right up to them tonight at the food booth and lost my nerve. I didn’t want them thinking I was looking for money or a chunk of their ranch. I don’t have any proof that we’re related.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe your mother could talk to them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nope,” he said, and forced a smile. “Emily’s gone, too. But considering that she never even told "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v(" who my father was, I doubt she’d get involved even if she were alive. If I hadn’t run into a friend of hers last week, I still wouldn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh,” she said softly. “Oh, I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, me too,” he said. “Would’ve been nice to know the guy responsible for my being here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah’s compassionate gaze gentled on his. And suddenly, there was something so special and giving about her—something so good—that he needed to take a tiny bit of it for himself. Swallowing the lump in his throat, he cupped her face, lowered his head and kissed her. Softly. Briefly. Then, not so briefly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Slowly, Jake eased away, feeling his blood pump harder, feeling the stirrings he’d been trying to ignore for the past hour finally surface.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah touched his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He searched her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then hungry lips found each other, and dancing became sweet, needy friction.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie rapped sharply on the door, shattering his thoughts as she breezed inside. “Here’s the paper. Hope there’s something promising in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake almost stood, then realized with a start that he’d gotten far too involved in his memory. “Thanks.” Taking the paper, he opened it to the want ads to cover his embarrassment. “Seems like that’s all I ever say to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No reason to. I haven’t done anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right. You’re only helping me find a place to live, and boarding Blackjack at your ranch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not mine, my family’s. And it doesn’t take a lot of time to feed and water one more horse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m still grateful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you’re still welcome.” Maggie paused for a moment, then spoke hesitantly. “Any chance you’ll be here for a while?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake glanced up from the disappointing listings. “I plan to be. Do you have errands to run?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, but I need to talk to Ross. We have tentative plans to meet at Aunt Ruby’s at eleven-thirty, but I can stay until Joe gets back if there’s something in the paper that piques your interest.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go,” he said. “Have lunch with your husband. From the looks of it, I’m out of luck unless I want to buy a used washer and dryer, or baby-sit from eight to four. If a crime wave hits, I’ll phone you at the café.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great,” she said with a bright smile. “See you later.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But as the door closed in the outer office, Jake’s thoughts returned to Sarah.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shoving the paper aside, he went to his office window, remembering again how extraordinary their lovemaking had been. An illogical stab of jealousy followed as he imagined her with Vince Harper.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning from the window, he started back to his desk. How could she have let Harper touch her, feeling the way she did about the pony-tailed creep? Worse, how could she have let herself get preg—")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake froze in his tracks as that family picture he’d conjured earlier formed again in his mind and he realized why, aside from obvious reasons, it had looked all wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vince Harper had had blond hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake stopped breathing as his mind played a cautious game of connect the dots. First he ticked off the months since he’d made love with Sarah. Then he took a guess at her daughter’s age.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hair color didn’t necessarily prove parentage, he told himself as his heart pounded. Eye color didn’t, either, unless you had enough family history to factor in. But Sarah Harper was a brown-eyed blonde, and her ex-husband’s hair had been light.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Kylie Harper had blue eyes, and her hair was black.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Every adrenaline-juiced nerve, muscle and cell in Jake’s body sprang to life, and he damned Maggie’s early lunch. He had to see Sarah again.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’s becoming a little person, Sarah thought, shooing Kylie into the single bed in the first-floor toy room. But she still had that precious baby voice. That sweet, trusting baby squeak that often replaced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("L")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("R")]), _vm._v(" sounds with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("W")]), _vm._v("s, but managed to make herself understood very well, anyway. For a child who wasn’t yet two and a half, Kylie had an amazing vocabulary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mommy, I’n not tired yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah kissed the tip of her nose and covered her with a thin blanket. Then she squeezed into the narrow bed with her daughter, dodging half a dozen stuffed animals, a green dinosaur and a naked Barbie doll with wild hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know you’re not,” Sarah murmured. “But Mommy and Pooh are, so we’re all going to take a nap before we start supper. Now, you close your eyes and I’ll close mine, and before you know it, it’ll be time to wake up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s look at Kylie pictures!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah smiled. “Nope, we’ll look at the photo album later. It’s time to dream.” In only a few minutes, dark-lashed lids closed over blue eyes like her daddy’s, and Kylie was asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah felt her heart break.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Time to dream? If she ever slept again, her sleep would be filled with nightmares. One indiscretion. One terrible, wonderful mistake three years ago had given her the child she’d always wanted. But it had also given her the greatest fear she’d ever known. He would be living here now, seeing them at the market and church, bumping into them on the street.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had a right to know. A man like Jake—who’d been raised by a rootless single mother then shuffled from foster home to foster home when she died—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("deserved")]), _vm._v(" to know he had a daughter. But if she told him, what then?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even joint custody would be a horror, and it could happen, given the courts’ near-manic sympathy for fathers’ rights lately. Just last week, a friend of Sarah’s had lost a custody battle that should never have been decided in the father’s favor. If that happened, and Kylie was taken from her…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sarah tried to contain her panic. Maybe they should leave—just pack up and move. It wouldn’t be easy to establish her catering business in another town, and her dad would miss them, as they would miss him. But he had friends, didn’t he? He and Judge Quinn were always doing something together.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tears welled, and Sarah touched her forehead to her sleeping child’s. No, she couldn’t do that to her father. With her mother’s death still a raw ache after nearly two years, he depended on Sarah for love and support. But Kylie was another matter. Kylie’s laughter and kisses had become his lifeline. She couldn’t take that from him, just as she couldn’t deprive Kylie of the grandfather she adored.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Blinking back tears, Sarah slid her arm out from under Kylie’s neck, backed out of the bed below the protective side rail, then moved silently into the hall and closed the door to within a crack.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She would not cry, she told herself. She would not be a weak, blubbering wreck ever again. The last time she’d allowed that to happen, a lonely deputy sheriff on holiday to meet the brothers he’d never known had found her by Cotton Creek, and Kylie had been conceived.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She would pull herself together and tell herself she was overreacting. She would make the meatballs and sauce for the Tully girl’s nuptials and put some aside for tonight’s supper. She would not let Jake Russell’s threatening presence get to her. And she would "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" cry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All right, she decided as her tears rolled, anyway, she would cry. But she would do it quietly.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-600617c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459218130_ch01.vue
// module id = 78
// module chunks = 0